import { useState } from "react";

type PageState = {
  page: number;
  perPage: number;
};

export function usePage(initialPage = 1, initialPerPage = 10) {
  const [pagination, setPagination] = useState<PageState>({
    page: initialPage,
    perPage: initialPerPage,
  });

  const setPage = (page: PageState) => setPagination(page);

  const reset = () =>
    setPagination({ page: initialPage, perPage: initialPerPage });

  return {
    ...pagination,
    setPage,
    reset,
  };
}
